import { Controller } from '@hotwired/stimulus'
import { disableScroll, enableScroll } from '../utils/global'

// Управляет статическим окном OAuth-входа из layout. Контроллер расположен на
// body, чтобы одна кнопка в header могла открыть dialog в конце документа.
export default class LoginModalController extends Controller {
  static targets = ['dialog']

  connect() {
    this.trigger = null
    this.scrollLocked = false
  }

  disconnect() {
    if (this.scrollLocked) enableScroll()
  }

  open(event) {
    event.preventDefault()
    if (!this.hasDialogTarget || this.dialogTarget.open) return

    this.trigger = event.currentTarget
    this.applyOrigin(event.params?.origin)
    this.dialogTarget.showModal()
    disableScroll()
    this.scrollLocked = true
  }

  // Кнопка-открывашка может задать, куда вернуть пользователя после входа
  // (data-login-modal-origin-param). Без параметра остаётся origin из формы —
  // текущая страница. Дефолт запоминается, чтобы следующее открытие без
  // параметра не унаследовало чужой адрес.
  applyOrigin(origin) {
    this.dialogTarget
      .querySelectorAll('input[name="origin"]')
      .forEach((input) => {
        if (!('defaultOrigin' in input.dataset))
          input.dataset.defaultOrigin = input.value
        input.value = origin || input.dataset.defaultOrigin
      })
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    this.dialogTarget.close()
    this.unlockScroll()
    this.trigger?.focus()
  }

  closeOnBackdrop(event) {
    // У native dialog клик по backdrop приходит на сам dialog.
    if (event.target === this.dialogTarget) this.close(event)
  }

  // Действие висит на всём абзаце соглашения: ссылки в нём приходят из перевода
  // (один ключ auth.login.agreement_html), поэтому привязаться к самой ссылке
  // через data-action нельзя — редактор потерял бы атрибут при правке текста.
  // Отсюда проверка href: клики по «условиям» и «конфиденциальности» — обычные
  // переходы и обрабатываться не должны.
  openCookiePolicy(event) {
    if (!event.target.closest('a[href="#cookie-policy"]')) return

    event.preventDefault()
    this.close()
    window.CookieConsent?.showPreferences()
  }

  unlockScroll() {
    if (!this.scrollLocked) return

    enableScroll()
    this.scrollLocked = false
  }
}
